import * as React from "react"
import { CircleCloseIcon } from "../../../common/icons"
import { useSetRecoilState } from "recoil"
import layoutStates, { changeTabSelector } from "../../../../recoil/atoms/layout"
import { addHitAreaStyle } from "../../../../util/styleUtils"
import { IconButtonProps } from "src/components/common/buttons"

type CloseTabsIconProps = {} & IconButtonProps

const _CloseTabsIcon = ({ ...rest }: CloseTabsIconProps) => {
  const setVisibleMobileFSTabs = useSetRecoilState<boolean>(
    layoutStates.visibleMobileFSTabs
  )
  const setTab = useSetRecoilState(changeTabSelector)

  const handleCloseTabs = () => {
    setVisibleMobileFSTabs(false)
    // un-select tab
    setTab("closed")
  }

  return (
    <CircleCloseIcon
      onTouchStart={handleCloseTabs}
      background="rgba(0, 0, 0, 0.2)"
      aria-label="circle-close-icon"
      position="absolute"
      top={"-28px"}
      left={"10px"}
      {...addHitAreaStyle()}
      {...rest}
    />
  )
}

export const CloseTabsIcon = React.memo(_CloseTabsIcon)
